<template>
  <div class="home">
    <!-- will redirect to app -->
  </div>
</template>

<script lang="ts">
import { Component, Vue } from "vue-facing-decorator"

@Component({})
export default class Home extends Vue {
  // Methods
  created() {
    this.$router.push({name: "AppSiteAccess"})
  }
}
</script>

<style scoped>
.home {
  display: flex;
  align-items: flex-start;
  justify-content: flex-start;
  flex-direction: column;
  padding: 3rem;
  overflow: scroll;
  height: 90vh;
}
</style>
